<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <strong>Unidad de Negocio: {{ bUnits.name}}</strong>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-12">
                <input type="file" id="file-costcenter-massive-update" required/>
            </div>
        </div>     
        <div class="row mt-4">       
            <div class="col-md-12">
                <button @click="upload" class="btn btn-block btn-success">
                    <i class="fa fa-save"></i>
                    Procesar
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { Put } from "../../helper/axios.js";

export default {
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            Put,
        };
    },
    props: ["bUnits"],

    methods: {
        upload() {
            let formData = new FormData();
            let file = document.getElementById("file-costcenter-massive-update");

            if (file)
            {
                file = file.files[0];
                formData.append("file", file);
                formData.append("businessUnitId", this.bUnits.id);
                try {
                    this.$store.commit("setLoading", true);
                    this.Put(`${this.apiUrl}v1/businessunits/massiveCostCenterUpdate`, formData, (res) => {
                        this.$store.commit("setLoading", false);
                        window.toastr.success("Se ha procesa la carga masiva de Centros de Costos correctamente. " + res.data);
                        this.$emit("updateDone", true);
                });
                } catch (error) {
                    alert("Error al procesar el archivo.");
                    console.error(error);
                }
            }
        }
    }
}
</script>